const projectStorageKey = 'project.settings';
const projectCommonStorageKey = 'project';

interface ProjectStorageType {
  selectedScriptId: number;
}

interface ProjectCommonStorageType {
  mediaPageSize: number;
}

export const getProjectSettings = (projectId: number): ProjectStorageType | null => {
  const settings = localStorage.getItem(`${projectStorageKey}.${projectId}`);

  if (settings) {
    try {
      return JSON.parse(settings) as ProjectStorageType;
    } catch (e) {
      console.error(e);
    }
  }

  return null;
};

export const saveProjectSetting = <K extends keyof ProjectStorageType>(
  projectId: number, key: K, value:ProjectStorageType[K],
) => {
  const settings = getProjectSettings(projectId);

  if (settings) {
    settings[key] = value;
    localStorage.setItem(`${projectStorageKey}.${projectId}`, JSON.stringify(settings));
  } else {
    const newSettings = {
      [key]: value,
    };
    localStorage.setItem(`${projectStorageKey}.${projectId}`, JSON.stringify(newSettings));
  }
};

export const getCommonProjectSettings = (): ProjectCommonStorageType | null => {
  const settings = localStorage.getItem(projectCommonStorageKey);

  if (settings) {
    try {
      return JSON.parse(settings) as ProjectCommonStorageType;
    } catch (e) {
      console.error(e);
    }
  }

  return null;
};

export const saveCommonProjectSetting = <K extends keyof ProjectCommonStorageType>(key: K, value: ProjectCommonStorageType[K]) => {
  const settings = getCommonProjectSettings();

  if (settings) {
    settings[key] = value;
    localStorage.setItem(projectCommonStorageKey, JSON.stringify(settings));
  } else {
    const newSettings = {
      [key]: value,
    };
    localStorage.setItem(projectCommonStorageKey, JSON.stringify(newSettings));
  }
};
